import axios from 'axios';
import { Avatar, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import moment from 'moment';

import Page from '../../components/Page';
import Services from '../../service/Services';
import { localdata } from '../../service/localdata';
import UserPermission from '../../sections/@dashboard/user/UserPermission';

const { MaterialReactTable } = require("material-react-table");
const { useEffect, useMemo, useState } = require("react");


// ----------------------------------------------------------------------
const RolesList = () => {

    const columns = useMemo(() => [
        {
            accessorKey: 'Name', Cell: ({ cell, row }) => {
                return <div className='d-flex align-items-center'><Avatar className='me-2' src={row?.original?.picture} /> {row?.original?.name || '-'}</div>
            },
            header: 'Full Name'
        },
        { accessorKey: 'email', header: 'Email' },
        { accessorKey: 'gender', header: 'Gender' },
        {
            accessorKey: 'dateOfBirth', header: 'Date of Birth', Cell: ({ cell, row }) => {
                return <div className='d-flex align-items-center'>{moment(cell.getValue()).format('DD-MMM-YYYY') || '-'}</div>
            }
        },
        {
            accessorKey: 'updatedAt', header: 'Updated At', Cell: ({ cell, row }) => {
                return <div className='d-flex align-items-center'>{moment(cell.getValue()).format('DD-MMM-YYYY') || '-'}</div>
            }
        },
        {
            accessorKey: 'View', header: 'Action', Cell: ({ cell, row }) => {
                return <UserPermission item={row.original} />
            }
        },
    ], []);

    const [data, setDate] = useState([]);
    const [isLoading, setLoading] = useState();

    useEffect(() => {
        refresh();
    }, []);

    const refresh = () => {
        const userData = localdata.GET_DATA();
        setLoading(true);
        axios
            .get(Services.GET_ALL_USERS(0, 1000), {
                headers: {
                    Authorization: `Bearer ${userData.token}`,
                },
            })
            .then((res) => {
                console.log(res.data);
                if (res.data.results.length > 0) {
                    setDate(res.data.results);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    return (
        <div className="w-100 p-4">
            <Page title="User">
                <div className='d-flex justify-content-between pb-4'>
                    <h4> Permissions</h4>
                </div>
                <MaterialReactTable
                    columns={columns}
                    isLoading={isLoading}
                    data={data}
                    enableColumnOrdering
                />

            </Page>

        </div>
    )
}

export default RolesList;